<template>
    <div>
      <nav class="navbar navbar-expand-lg navBg">
        <div class="container-fluid">
          <span class="navbar-brand">
            <img src="@/assets/site_img/logo.png" alt="Logo" class="logo-img mt-1">
          </span>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav mx-auto">
              <li class="nav-item mt-2 mx-4 my-sm-3 my-lg-0">
                <router-link to="/applicantList" class="text" draggable="false"
                    :class="{ 'active-link': $route.path === '/applicantList' || $route.path.startsWith('/applicantPreview')}" exact>
                    応募者一覧
                </router-link>
              </li>
              <li class="nav-item mt-2 mx-4 my-sm-2 my-lg-0" v-if="permission && (permission.data.app_create === 1 || permission.data.app_update === 1  || permission.data.app_delete === 1)">
                <router-link :to="$route.params.uid ? { name: 'applicantRegister', params: { uid: uid } } : { path: '/applicantRegister' }"
                    draggable="false" class="text" :class="{ 'active-link': $route.path.startsWith('/applicantRegister') }" exact>
                    応募者登録
                </router-link>
              </li>
              <li class="nav-item mt-2 mx-4 my-sm-3 my-lg-0">
                <router-link to="/setting" class="text" draggable="false" :class="{ 'active-link': $route.path === '/setting'}" exact>
                    各種設定
                </router-link>
              </li>
              <li class="nav-item mt-2 mx-4 my-sm-3 my-lg-0" v-if="permission && (permission.data.job_create === 1 || permission.data.job_update === 1  || permission.data.job_delete === 1)">
                <router-link to="/jobTypeRegister" class="text" draggable="false"  :class="{ 'active-link': $route.path === '/jobTypeRegister'}" exact>
                    職種登録
                </router-link>
              </li>
              <li class="nav-item mt-2 mx-4 my-sm-2 my-lg-0" v-if="role === 'M'">
                <router-link to="/userRegister" class="text" draggable="false"  :class="{ 'active-link': $route.path === '/userRegister'}" exact>
                    ユーザー登録
                </router-link>
              </li>
              <li class="nav-item mt-2 mx-4 my-sm-2 my-lg-0" v-if="role === 'M'">
                <router-link :to="$route.params.uid ? { name: 'userPermission', params: { uid: uid } } : { path: '/userPermission' }"
                  draggable="false" class="text" :class="{ 'active-link': $route.path.startsWith('/userPermission') }" exact>
                    ユーザー制限
                </router-link>
              </li>
            </ul>
            <div class="dropdown">
                <button class="dropbtn mt-2" v-on:click="toggleDropdown"><span class="bi bi-person-circle fs-1 text-white"></span>
                </button>
                <div class="dropdown-content d-block" v-if="isDropdownVisible">
                    <li><span class="d-block mt-3 no-cursor"><i class="bi bi-person-vcard"></i> User ID: <b>{{ userID }}</b></span></li>
                    <li><span class="d-block email no-cursor text-load-email"><i class="bi bi-envelope-at"></i> Email: <b data-toggle="tooltip" v-bind:title="userEmail">{{ userEmail.replace('', '&#8203;') }}</b></span></li>
                    <li>
                        <span class="fw-bold">
                        <router-link to="/changePassword" class="mx-0 text-decoration-none text-black">
                            <i class="bi bi-gear"></i>
                            Change Password
                        </router-link>
                        </span>
                    </li>
                    <li>
                        <div class="fw-bold mx-0 pointer text-danger" v-on:click="logoutHandler">
                            <i class="bi bi-power"></i>
                            <span class="logoutText"> Logout</span>
                        </div>
                    </li>
                </div>
            </div>
          </div>
        </div>
    </nav>
      <div ref="topMenu" tabindex="-1" ></div>
      <button v-on:click="scrollToTop" class="btn btn-outline-secondary scroll-top-btn circle-btn" title="Go To Top">
        <i class="bi bi-chevron-up"></i>
      </button>
      <div class="container page">
        <slot/>
      </div>
    </div>
</template>
<style lang="css" scoped src="@/assets/css/menuLayout.css"></style>
<script>
import { mapState, mapActions } from 'vuex';
import { performLogout } from '@/Util/logout';
import timeoutMixin from '@/Util/timeoutMixin.js';
export default {
  mixins: [timeoutMixin],
  computed: {
    ...mapState(['userEmail', 'userID', 'token', 'role', 'permission']),
  },
  data() {
    return {
       isDropdownVisible: false,
       uid: null,
    };
  },
  methods: {
    ...mapActions(['logout']),
    // ログアウト操作を実行する
    async logoutHandler() {
      this.$store.dispatch('setSessionExpiredMessage', '');
      localStorage.setItem('logoutFlag', true);
      await performLogout(this.userID, this.userEmail, this.token, this.logout, this.$router);
    },
    // ユーザープロファイルのドロップダウンを切り替えする
    toggleDropdown() {
        this.isDropdownVisible = !this.isDropdownVisible;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('setSessionExpiredMessage', '');
        next();
    },
};
</script>
